import { cn } from '@Core/Helpers';
import { Loader2Icon } from 'lucide-react';
import React, { ComponentProps } from 'react';

export default function Spinner({ className, ...props }: ComponentProps<"svg">) {
    return (
        <Loader2Icon
            data-slot="spinner"
            role="status"
            aria-label="Loading"
            className={cn("size-3! animate-spin", className)}
            {...props}
        />
    )
}
